import React, { useEffect, useState } from 'react';
import { User } from 'src/graphql/generated/graphql';
import SvgNotifications from '@otp/icons/dist/Notifications';
import styles from './index.module.css';
import { Badge, Card, ClickAwayListener, Popper } from '@otp/ui';
import { useUnreadNotificationsCount } from 'src/hooks/query/use-unread-notifications-count';
import { NotificationsPopup } from 'src/components/notifications/popup/table/list';

interface UserNotifications {
  user?: User;
}

export const UserNotificationsPopper = ({ user }: UserNotifications) => {
  const [undreadNotificationsCount, setUnreadNotifications] = useState(0);
  const { data } = useUnreadNotificationsCount(!user, (data) =>
    setUnreadNotifications(data?.getUnreadNotificationsCount || 0),
  );
  useEffect(() => {
    setUnreadNotifications(data || 0);
  }, [data]);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  if (!user) {
    return null;
  }

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const onClickAway = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const badgeDisplayLimit = 100;
  const id = open ? 'simple-popper' : undefined;

  return (
    <ClickAwayListener onClickAway={onClickAway}>
      <div>
        <div className={styles.wrapper} onClick={handleClick}>
          <Badge
            color="primary"
            badgeContent={undreadNotificationsCount}
            max={badgeDisplayLimit}
          >
            <SvgNotifications
              aria-describedby={id}
              type="button"
            ></SvgNotifications>
          </Badge>
        </div>
        <Popper
          placement="auto"
          id={id}
          open={open}
          anchorEl={anchorEl}
          disablePortal={true}
          modifiers={[
            {
              name: 'computeStyles',
              options: {
                // for some reason, when gpuAcceleartion is on, the element pops outside of the viewport
                // disabling it, causes it to rmemain withing the viewPort despite adaptive styles and preventOverflow
                gpuAcceleration: false,
              },
            },
          ]}
        >
          <Card className={styles.cardWrapper}>
            {/** the seeAllCallback is used to prevent the resize of the notifications window when the button is clicked
             * instead, it will dismiss the popper, which is also sensible user experience, since, the intention is to
             * navigate to the list view, it doesn't make sense to keep the popper open
             */}
            <NotificationsPopup seeAllCallback={() => setAnchorEl(null)} />
          </Card>
        </Popper>
      </div>
    </ClickAwayListener>
  );
};

export default UserNotificationsPopper;
